import type { RouteRecordRaw } from "vue-router";
import { crudRoutes } from "./helpers/crudRoutes";
import { USER_ADMIN_ROLES } from "../roleGuard";

// Auth-only routes — inside the auth shell (requiresAuth inherited from parent)
export const adminRoutes: RouteRecordRaw[] = [
  ...crudRoutes({
    path: "users",
    listComponent: () => import("@/views/Users/Users.vue"),
    formComponent: () => import("@/views/Users/UserForm.vue"),
    extra: [
      {
        path: "/users/notifications",
        name: "users-notifications",
        component: () => import("@/views/Users/Notifications.vue"),
      },
    ],
    // `crudRoutes` propagates this onto the `extra` records too, so
    // /users/notifications inherits the same super-admin gate as the rest.
    meta: { requiresRole: USER_ADMIN_ROLES },
  }),
  ...crudRoutes({
    path: "client-affairs",
    listComponent: () => import("@/views/ClientAffairs/ClientAffairs.vue"),
    formComponent: () => import("@/views/ClientAffairs/ClientAffairsForm.vue"),
    extra: [
      {
        path: "/client-affairs/history/:id",
        name: "client-affairs-history",
        component: () =>
          import("@/views/ClientAffairs/ClientAffairsHistory.vue"),
        props: true,
      },
    ],
  }),
  ...crudRoutes({
    path: "clients",
    listComponent: () => import("@/views/Business/Clients.vue"),
    formComponent: () => import("@/views/Business/ClientForm.vue"),
    editIdRequired: true,
  }),
  ...crudRoutes({
    path: "employees",
    listComponent: () => import("@/views/Employees/Employees.vue"),
    formComponent: () => import("@/views/Employees/EmployeeForm.vue"),
  }),
];
